import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from "@angular/common/http";
import { DxDataGridModule } from "devextreme-angular";
import { DpDatePickerModule } from 'ng2-date-picker';

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HeaderComponent } from "./layout/header/header.component";
import { PageLoaderComponent } from "./layout/page-loader/page-loader.component";
import { SidebarComponent } from "./layout/sidebar/sidebar.component";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { DynamicScriptLoaderService } from "./services/dynamic-script-loader.service";

@NgModule({
	declarations: [
		AppComponent,
		HeaderComponent,
		PageLoaderComponent,
		SidebarComponent,
	],
	imports: [
		BrowserModule,
		HttpClientModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		NgbModule,
		ReactiveFormsModule,
		DxDataGridModule,
		DpDatePickerModule
	],
	providers: [
		{ provide: LocationStrategy, useClass: HashLocationStrategy },
		DynamicScriptLoaderService
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
